import type { EditorState, NodeId } from "@craftjs/core";

export default function getCurrentNodeId(state: EditorState): NodeId {
  return state.events.selected.values().next().value;
}
